export default {
    methods: {
        i18n(property) {
            const postFix = localStorage.getItem('lang') === 'el' ? 'Greek' : 'English'
            return property + postFix
        },
        sortByName(a, b) {
            let nameField = this.$root.$i18n.locale === 'el' ? 'nameGreek': 'nameEnglish'

            if (a[nameField] < b[nameField]) {
                return -1
            }
            else if(a[nameField] > b[nameField]) {
                return 1
            }
            return 0
        }
    }
}